export function setCookie(name, value, timestamp) {
  let expires = ''
  if (timestamp) {
    const date = new Date()
    date.setTime(timestamp)
    expires = '; expires=' + date.toUTCString()
  }
  let secure = ''
  if (process.env.NODE_ENV === 'production') {
    secure = 'secure;'
  }
  document.cookie =
    name + '=' + (value || '') + expires + ';samesite=lax;' + secure + ' path=/'
}

export function getCookie(label) {
  const cookieLabel = label + '='
  const cookies = parseCookies(document.cookie)
  return findCookie(cookieLabel, cookies)
}

export function parseCookies(cookies) {
  if (typeof cookies === 'string') {
    return cookies.split(';')
  }
  return null
}

export function findCookie(cookieLabel, cookies) {
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i]
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length)
    }
    if (cookie.indexOf(cookieLabel) === 0) {
      cookie = cookie.substring(cookieLabel.length, cookie.length)
      if (cookie.charAt(0) === '=') {
        return cookie.slice(1)
      }
      return cookie
    }
  }
  return null
}

export function eraseCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;'
}
